import { Layout } from 'components';
import Home from 'pages';
import Calculator from 'pages/Calculator';
import ContactProfile from 'pages/ContactProfile';
import ContactUs from 'pages/ContactUs';
import FAQ from 'pages/FAQ';
import GetStarted from 'pages/GetStarted';
import Login from 'pages/Login';
import ManageContacts from 'pages/ManageContacts';
import ManageGroundStation from 'pages/ManageGroundStation';
import ManageSpaceCraft from 'pages/ManageSpacecraft';
import MyPage from 'pages/MyPage';
import Pricing from 'pages/Pricing';
import Promotion from 'pages/Promotion';
import ScheduleContact from 'pages/ScheduleContact';
import SignUp from 'pages/SignUp';
import ResetEmail from 'pages/SignUp/ResetEmail';
import ResetPassword from 'pages/SignUp/ResetPassword';
import ErrorPage from 'pages/ErrorPage';
import ManageS3 from 'pages/ManageS3';
import { WidgetSuccessPage } from 'pages/MyPage/Success';
import { FailPage } from 'pages/MyPage/Fail';
import RefundPolicy from 'pages/Policy/RefundPolicy';
import TermsOfUsePopup from 'components/Popup/TermsOfUsePopup';
import PersonalUsePopup from 'components/Popup/PersonalUsePopup';
import TossPopup from 'components/Popup/TossPopup';
import Dashboard from 'pages/Dashboard';
import PaymentSuccessPage from './pages/MyPage/PaymentSuccessPage';
import PaymentFailPage from './pages/MyPage/PaymentFailPage';
import PaymentLauncherPage from './pages/MyPage/PaymentLauncherPage';

import { Provider } from 'react-redux';
import { CookiesProvider } from 'react-cookie';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import PrivateRoute from 'route/PrivateRoute';
import store from './store';
import ManageSchedule from 'pages/ManageSchedule';
import ManagePayment from 'pages/ManagePayment';
import ManageUser from 'pages/ManageUser';
import ManageInquiry from 'pages/ManageInquiry';
import ManageMail from 'pages/ManageMail';
import ManagePromotion from 'pages/ManagePromotion';
import SpaceTimeTools from 'pages/SpaceTimeTools';
import Commanding from 'pages/Commanding';

const App = () => {

  return (
<Provider store={store}>
  <CookiesProvider>
    <HelmetProvider>
      <BrowserRouter>
        <Routes>
        {/* 개별 경로로 처리, Layout 없이 렌더링 */}
        <Route path="/" element={<Home />} />

        {/* 로그인/회원가입 등도 Layout 없이 개별 페이지 */}
        <Route path="/login" element={<Login />} />
        <Route path="/sign-up" element={<SignUp />} />
        <Route path="/pwInquiry" element={<ResetPassword />} />
        <Route path="/reset-email" element={<ResetEmail />} />
        <Route path="/success" element={<WidgetSuccessPage />} />
        <Route path="/fail" element={<FailPage />} />
        <Route path="/refund-policy" element={<RefundPolicy />} />
        <Route path="/terms-of-service" element={<TermsOfUsePopup />} />
        <Route path="/privacy-policy" element={<PersonalUsePopup />} />
        <Route path="/toss-of-use" element={<TossPopup />} />
        <Route path="/mypage/payment/success" element={<PaymentSuccessPage />} />
        <Route path="/mypage/payment/fail" element={<PaymentFailPage />} />
        <Route path="/mypage/payment/launcher" element={<PaymentLauncherPage />} />

        {/* Layout이 적용되는 내부 페이지들만 경로 분리 */}
        <Route element={<Layout title="IOPS SPACE" description="Your Gateway to Space IS HERE" />}>
          <Route path="pricing" element={<Pricing />} />
          <Route path="promotion" element={<Promotion />} />
          <Route path="calculator" element={<Calculator />} />
          <Route path="get-started" element={<GetStarted />} />
          <Route path="faq" element={<FAQ/>} />
          <Route path="contact-us" element={<ContactUs />} />
          <Route path="spacetime-tools" element={<SpaceTimeTools />} />

          {/* 로그인 권한 필요 */}
          <Route path="manage-spacecraft" element={<PrivateRoute component={ManageSpaceCraft} />} />
          <Route path="commanding" element={<PrivateRoute component={Commanding} />} />
          <Route path="my-page" element={<PrivateRoute component={MyPage} />} />
          <Route path="contact-profile" element={<PrivateRoute component={ContactProfile} />} />
          <Route path="schedule-contact" element={<PrivateRoute component={ScheduleContact} />} />
          <Route path="manage-contacts" element={<PrivateRoute component={ManageContacts} />} />
          <Route path="dashboard" element={<PrivateRoute component={Dashboard}/>} />
          <Route path="manage-ground-station" element={<PrivateRoute component={ManageGroundStation} requiredRole="ROLE_ADMIN" />} />
          <Route path="manage-s3" element={<PrivateRoute component={ManageS3} requiredRole="ROLE_ADMIN" />} />
          <Route path="manage-schedule" element={<PrivateRoute component={ManageSchedule} requiredRole="ROLE_ADMIN" />} />
          <Route path="manage-payment" element={<PrivateRoute component={ManagePayment} requiredRole="ROLE_ADMIN" />} />
          <Route path="manage-user" element={<PrivateRoute component={ManageUser} requiredRole="ROLE_ADMIN" />} />
          <Route path="manage-inquiry" element={<PrivateRoute component={ManageInquiry} requiredRole="ROLE_ADMIN" />} />
          <Route path="manage-mail" element={<PrivateRoute component={ManageMail} requiredRole="ROLE_ADMIN" />} />
          <Route path="manage-promotion" element={<PrivateRoute component={ManagePromotion} requiredRole="ROLE_ADMIN" />} />

        </Route>
        {/* 에러페이지*/}
        <Route path="*" element={<ErrorPage />} />

      </Routes>
      </BrowserRouter>
    </HelmetProvider>
  </CookiesProvider>
</Provider>

  );
};

export default App;
